export default __webpack_public_path__ + "static/media/Update-Address.1a1059f4.jpg";